export default "__VITE_ASSET__DUfea9iO__"